import type { SgmeSpBridgeCommonNewFormPriceUnit } from 'api/data-contracts';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';

export function toSecondaryMarketPriceType(
  priceType?: SgmeSpBridgeCommonNewFormPriceUnit,
): SecondaryPriceType | undefined {
  switch (priceType) {
    case 'Percent':
      return 'Percent';
    case 'ReferenceCurrency':
      return 'Amount';
    default:
      return undefined;
  }
}
